module.exports = __webpack_public_path__ + "media/images/quick_search/block-notas-2e281521c51c8d739aef5cbd243769e9.png";